<template>
    <div id="options" class="vs-con-loading__container">
        <div class="poka" v-show="(productOptions || []).length">
            <div v-for="(option, index) in productOptions" :key="option.id" :id="option.id" :class="{'highlight' : option.highlight }" class="mb-4">
                <div class="vx-row mx-2">
                <h3 header>{{ option.description }}</h3>
                <span class="fix-opts">
                    <span v-if="option.min" > Ao menos {{ getTextNumber(option.min) }}</span>
                    <span class="q-ml-md" v-if="option.max && !option.single"> {{ getSelectedOptionsCount(option) }} / {{ option.max }}</span>
                </span>
                </div>
                <a-list item-layout="horizontal" :data-source="option.items">
                    <a-list-item slot="renderItem" slot-scope="item">
                        <vs-radio v-if="option.single" v-model="option.selected" :vs-value="item.id" class="mx-4">
                            <h5 class="font-bold mb-0 ml-3">{{ item.description }}</h5>
                        </vs-radio>
                        <counter v-else-if="option.multi" v-model="item.selected" :min="item.min" :max="item.max || option.max" 
                            :disabled="getSelectedOptionsCount(option) === option.max" class="ml-2"/>
                        <vs-checkbox v-else v-model="item.selected" :disable="!item.selected && hasMaxSelected(option)"/>

                        <div style="flex: 1">
                            <h5 v-if="!option.single" class="font-bold mb-0" style="align-self: center">{{ item.description }}</h5>
                        </div>

                        <div>
                            <a slot="actions" v-if="item.value">
                                + {{ item.value | currency }}
                            </a>
                        </div>
                    </a-list-item>
                </a-list>
                <vs-divider v-if="index < productOptions.length - 1" border-style="dashed" />
            </div>
        </div>
        <a-textarea v-model="obs"
            class="mt-2"
            placeholder="Observações"
            :auto-size="{ minRows: 3, maxRows: 5 }"/>
        <div class="flex ml-1 mt-3" style="justify-content: space-between;">
            <h5 class="m-0" style="align-self: center;">Quantidade</h5>
            <counter v-model="quantity" :min="1" :max="20"/>
        </div>
        <vs-checkbox v-model="print" class="mt-4 mb-4 font-bold" size="large" :style="!print ? 'text-decoration: line-through;' : ''"> Imprimir na cozinha? </vs-checkbox>
        
        <a-button v-if="product" type="danger" class="mt-3" id="btn-add" height="50px" block size="large"
            @click="order">
            Adicionar {{ totalPrice | currency }}
        </a-button>
    </div>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex';
    import extenso from 'extenso';
    import _misc from '@/assets/utils/misc.js'

    import Counter from '../Counter';

    function sortItems ([key1, value1], [key2, value2]) {
        return value1.order - value2.order;
    }

    export function processOptions (productOptions) {
        return productOptions && productOptions.filter(o => hasSelection(o))
            .reduce((prev, opt) => ({ ...prev, [opt.id]: withSelectedItemsInObjects(Object.assign({}, opt)), }), {});
    }

    function withSelectedItemsInObjects (opt) {
        try {
            const selections = opt.single ?
            opt.items.filter(i => i.id === opt.selected) :
            opt.items.filter(i => i.selected);
            const items = {};
            selections.forEach(s => {
            items[s.id] = s;
            });
            opt.items = items;
            return opt;
        } catch {
            return opt;
        }
    }

    function simplifyProduct (product) {
        const { description, image, id, value, } = product;
        const productType = product.productType &&
            { id: product.productType.id, description: product.productType.description, };
        return { description, image, id, productType, value, };
    }

    function hasSelection (option) {
        return option.single ?
            option.selected :
            option.items.filter(i => i.selected).length;
    }

    export default {
        components: { Counter },
        props: {
            productDescription : String,
            productId: {
                type: String,
                required: true
            },
            table: Object,
            editingOrder: Object
        },
        data() {
            return {
                productOptions: null,
                obs: '',
                quantity: 1,
                printModel: true
            }
        },
        computed: {
            totalPrice () {
                return this.quantity * (((this.product.value || 0) + +this.optionsPrice) || 0);
            },
            optionsPrice () {
                if (!this.productOptions)
                    return 0;
                return this.productOptions.reduce((subTotal, opt) => {
                    if (opt.single && Array.isArray(opt.items)) {
                        const selected = opt.items.find(i => i.id === opt.selected);
                        return subTotal + ((selected && selected.value) || 0);
                    }
                    if (!Object.values(opt.items).filter(v => v.value).length)
                    return subTotal;
                    return subTotal + Object.values(opt.items).filter(v => v.value).reduce((acc, curr) => {
                    return acc + (curr.selected ? opt.multi ?
                        curr.selected * +curr.value :
                        +curr.value :
                        0);
                    }, 0);
                }, 0) || 0;
            },
            print: {
                get () {
                    return this.printModel;
                },
                set (v) {
                    this.printModel = v;
                    localStorage['defaultToPrint'] = v;
                }
            },
            product () { return this.products[this.productId]; },
            ...mapState('product', ['products'])
        },
        methods: {
            hasMaxSelected (options) {
                if (!options.max)
                    return false;
                return this.getSelectedOptionsCount(options) >= options.max;
            },
            getSelectedOptionsCount (options) {
                return Object.values(options.items).reduce((acc, curr) => {
                    return (acc + curr.selected) || 0;
                }, 0);
            },
            optionsAsArray (opts, values) {
                if (!opts)
                    return;
                return Object.entries(opts)
                    .filter(([key, value]) => value.active !== false)
                    .sort(sortItems)
                    .map(([key, value]) => {
                    const selectedValue = values && values[key];
                    if (value.type === 'multiple')
                        value.multi = true;
                    if (value.type === 'single')
                        value.single = true;
                    if (value.size) {
                        value.description = value.size;
                        if (value.unit && value.unit.shortDesc) {
                            value.description += ` (${value.unit.shortDesc})`;
                        }
                    }
                    const obj = {
                        ...value,
                        items: this.optionsAsArray(value.items, selectedValue),
                        id: key,
                    };
                    
                    if (value.single)
                        this.$set(obj, 'selected', (selectedValue && selectedValue.selected) || value.selected || '');
                    else if (obj.items)
                        obj.items.forEach(v => { this.$set(v, 'selected', ((selectedValue && selectedValue.items[v.id] && selectedValue.items[v.id].selected)) || value.selected || false); });
                    return obj;
                });
            },
            setupOrder () {
                const { editingOrder, } = this;
                if (this.product.options) {
                    const options = JSON.parse(JSON.stringify(this.product.options));
                    this.productOptions = this.optionsAsArray(options, editingOrder && editingOrder.options).sort((a, b) => a.order - b.order);
                }
                if(editingOrder) {
                    this.quantity = editingOrder.quantity
                }
            },
            validateOrder () {
                const requiredOptions = this.productOptions.filter(opts => opts.min);
                if (!requiredOptions.length)
                    return true;
                const missingMultiSelection = requiredOptions.filter(opts => opts.items.map(x => x.selected).reduce((prev, curr) => prev + curr) < opts.min);
                const missingSingleSelection = requiredOptions.filter(m => m.single && !m.selected);
                const missing = [...missingMultiSelection, ...missingSingleSelection].filter(i => i).sort((a, b) => a.order - b.order);
                if (!missing.length)
                    return true;
                const first = requiredOptions.find(opt => opt === missing[0]);
                this.highlightRequired(first);
                return false;
            },
            highlightRequired (elem) {
                if (!elem)
                    return;
                setTimeout(() => {
                    document.getElementById(elem.id).scrollIntoView({behavior : "smooth", block : "center"})
                    this.$set(elem, 'highlight', true);
                    setTimeout(() => {
                        elem.highlight = false;
                    }, 1300);
                }, 200);
            },
            async order () {
                if (!this.validateOrder())
                    return;
                const { editingOrder, quantity, obs, product, productOptions, totalPrice, table, print } = this;
                
                try {
                    const order = {
                        key : _misc.generateId(21),
                        id: editingOrder && editingOrder.id,
                        options: processOptions(productOptions),
                        quantity,
                        obs,
                        print : print,
                        product: simplifyProduct(product),
                        value: totalPrice,
                        express: product.isExpress,
                        dispatched: product.dispatched,
                    };
                    if (table) {
                        if (this.editingOrder) {
                            this.$vs.loading({ container: '#options' });
                            this.$vs.loading({ container: '#btn-add', scale : 0.5 });
                            await this.editOrder({ order, tableId: table.id });
                            this.$notification.success({
                                zIndex : 9999999,
                                message: this.$t('success'),
                                description: 'Pedido editado com sucesso!'
                            });
                        } else {
                            this.addProductOrder(order)
                            // await this.createOrder( { order, tableId: table.id });
                            // this.$notification.success({
                            //     message: this.$t('success'),
                            //     description: 'Pedido realizado com sucesso!'
                            // });
                        }
                    } else {
                        if (this.editingOrder)
                            this.removeItem(this.editingOrder);
                        this.addToDelivery(order)
                    }

                    this.cleanUp();
                    this.$emit('onClosePanel', false);
                } catch (err) {
                    this.$error({
                        zIndex : 9999999,
                        title: 'Erro!',
                        content: `ao realizar pedido: ${err.message}`
                    })
                } finally {
                    this.$vs.loading.close('#options > .con-vs-loading');
                    this.$vs.loading.close('#btn-add > .con-vs-loading');
                }
                
            },
            cleanUp() {
                this.obs = '';
                this.quantity = 1;
                this.setupOrder();
            },
            getTextNumber (number) { return extenso(number); },
            ...mapActions('product', ['fetchProducts']),
            ...mapActions('order', ['createOrder', 'editOrder']),
            ...mapMutations('delivery', ['addToDelivery', 'removeItem']),
            ...mapMutations('order', ['addProductOrder'])
        },
        async mounted () {
            await this.fetchProducts( { productId: this.productId });
            this.setupOrder();
            this.$emit('loadedProduct', this.productId);
            this.printModel = localStorage['defaultToPrint'] !== 'false';
        },
    }
</script>

<style lang="scss" scoped>
.highlight {
    animation: blink 0.8s steps(10, start) infinite;
}
@keyframes blink {
    0% {
      background: #CCC;
    }
    25% {
      background: #CCC0;
    }
    50% {
      background: #CCC;
    }
    75% {
      background: #CCC0;
    }
  }
.fix-opts {
    flex: 1;
    text-align: end;
    padding-top: 4px;
}

.poka {
    height: calc(100vh - 450px);
    overflow-y: auto;
}
</style>